$(document).ready(function() { 
$(window).scroll(function(){
    var $sections = $('.faq_box');
    $sections.each(function(i,el){
        var top  = $(el).offset().top-100;
        var bottom = top +$(el).height();
        var scroll = $(window).scrollTop();
        var id = $(el).attr('id');
        if( scroll > top && scroll < bottom){
            $('.left_links li a.active').removeClass('active');
            $('.left_links li a[href="#'+id+'"]').addClass('active');

        }
    })
});

  $(".left_links li a").click(function() {
        var id = $(this).attr("href")
        $('html, body').animate({
            scrollTop: $(id).offset().top - 70
        }, 500);
    });
  });